import '../MortgageBuyOrDie.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';

import { cnMrtgBuyOrDie } from '../MortgageBuyOrDieModal';

export function MortgageBuyOrDieFormField({
    text,
    children
}: React.PropsWithChildren<{
    text: string;
}>): React.ReactElement {
    return (<div className={cnMrtgBuyOrDie('form-field')}>
        <Typography bold variant='primary-alone'>{text}</Typography>
        {children}
    </div>);
}
